import { HttpParams } from '@angular/common/http';

type QueryParamValue = boolean | number | string | null | undefined;
type QueryParamArrayValue = Array<boolean | number | string> | null | undefined;

class HttpParamsBuilder {
  private params = new HttpParams();

  set(key: string, value?: QueryParamValue): this {
    if (value !== null && value !== undefined) {
      this.params = this.params.set(key, value);
    }

    return this;
  }

  from(params: Record<string, QueryParamValue>): this {
    Object.entries(params).forEach(([key, value]) => this.set(key, value));

    return this;
  }

  array(key: string, values?: QueryParamArrayValue): this {
    values?.forEach((value) => {
      this.params = this.params.append(key, value);
    });

    return this;
  }

  arrays(params: Record<string, QueryParamArrayValue>): this {
    Object.entries(params).forEach(([key, values]) => this.array(key, values));

    return this;
  }

  json<T>(key: string, value?: T | null): this {
    if (value) {
      this.params = this.params.set(key, JSON.stringify(value));
    }

    return this;
  }

  paging(pageIndex?: number | null, pageSize?: number | null): this {
    return this.set('pageIndex', pageIndex).set('pageSize', pageSize);
  }

  table(filters?: unknown, sort?: unknown): this {
    return this.json('filters', filters).json('sort', sort);
  }

  build(): HttpParams {
    return this.params;
  }
}

export function httpParams(): HttpParamsBuilder {
  return new HttpParamsBuilder();
}
